// Master switch for ForgeRock: OTP verification (OtpModal / ForgeRockApp),
// the /purchase/newcars/check redirect gate, and the OAuth callback-path
// mount skip in main.ts. With it off the app behaves as if ForgeRock had been
// removed entirely.
//
// Seeds store.state.app.forgerockEnabled. Components read the store getter
// `forgerockEnabled`; this constant is only read where the store is not yet
// available (router/index.ts builds its routes at module load and the store
// imports the router, so the router cannot import the store).
export const FORGEROCK_ENABLED = false;
